import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { PlazosDenuncia } from '../model/plazosDenuncia';
import { Historico } from '../model/historico';
import { environment } from "../../environments/environment.prod";
import { DatePipe } from '@angular/common';
import { Receptor } from '../model/receptor';
import { Rol } from '../model/rol';
import { noWhitespaceValidator } from '../shared/custom-validator/custom-validator.component';
import { Informes } from '../model/informes';

@Component({
  selector: 'app-enviar-receptor',
  templateUrl: './enviar-receptor.component.html',
  styleUrls: ['./enviar-receptor.component.css'],
  providers: [DatePipe]
})
export class EnviarDenunciaReceptorComponent implements OnInit {
  assetsUrl: string = environment.baseAssetsUrl;
  historico: Historico[];
  validatingForm: FormGroup;
  IsHiddenForm: boolean = false;
  plazos: PlazosDenuncia[];
  receptor: Receptor[];
  textoInforme: string;
  informes: Informes[];
  roles: Rol[];
  isActiveIdPersonalizable: boolean = false; //Is Active Id Custom
  charCount: number = 0;
  maxCharCount: number = 4000;
  private lastValidHTML: string = '';

  @Input() denuncia: DatosDenuncia;
  constructor(private apiService: ApiService, private auth: AuthService, private router: Router, private toastr: ToastrService, private translate: TranslateService, private datepipe: DatePipe) { }

  ngOnInit(): void {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);
    this.validatingForm = new FormGroup({
  enviarDenunciaReceptor: new FormControl(false),
  textoInforme: new FormControl('')
});


    //check if idPersonalizado is active
    this.setupPersonalizable();

    this.apiService.searchInformes(this.auth.getSociedad(), this.denuncia[0].id_denuncia).subscribe({
      next: (informes2) => {
        this.informes = informes2.data;
      }, error: () => {
        this.informes = [];
      }
    });
  }

  get enviarDenunciaReceptor() {
    return this.validatingForm.get('enviarDenunciaReceptor');
  }
  get texto() {
    return this.validatingForm.get('textoInforme');
  }
  get isTextoExcedido(): boolean {
  return this.charCount > this.maxCharCount;
}


  sendToReceiver() {
    if (this.enviarDenunciaReceptor.value == true) {
      if (this.charCount > 4000) {
        this.toastr.error(this.translate.instant('texto_266'), this.translate.instant('texto_243'));
        return;
      }

      // Search receiver users assigned to the complaint
      this.apiService.searchReceptorByIdDenuncia(this.denuncia[0].id_denuncia, '0')
        .subscribe((receptor: Receptor[]) => {
          this.receptor = receptor;
          if (this.receptor.length === 0) {
            this.toastr.error(this.translate.instant('texto_879'), this.translate.instant('texto_533'));
            return;
          }

          // Update qsc_denuncias user and set habilitado = 1 to receiver users
          this.apiService.searchInvestigatorByIdDenuncia(this.denuncia[0].id_denuncia, '11')
            .subscribe((receptor2: Receptor[]) => {
              if (receptor2.length === 0) {
                this.toastr.error(this.translate.instant('texto_531'), this.translate.instant('texto_533'));
                return;
              }

              // Update qsc_denuncias and set informe_gestor
              const plainTextInforme = this.extractPlainText(this.textoInforme);
              this.apiService.sendReportByIdDenuncia(this.denuncia[0].id_denuncia, plainTextInforme, '11', this.auth.getIdUser())
                .subscribe((res) => {
                  if (res !== 200) {
                    this.toastr.error(this.translate.instant('texto_935'), this.translate.instant('texto_813'));
                    return;
                  }

                  // update wsc_denuncias and set fase, update qsc_hist_fases_denuncia
                  this.apiService.updateComplaintById(this.denuncia[0].id_denuncia, '0', this.auth.getSociedad(), '', '')
                    .subscribe((res) => {
                      if (res !== 200) {
                        this.toastr.error(this.translate.instant('texto_935'), this.translate.instant('texto_813'));
                        return;
                      }

                      this.toastr.success(this.translate.instant('texto_532'), this.translate.instant('texto_520'));
                      const idShown = this.getIdDenunciaShown();
                      const url = environment.base + '/editar-denuncia/' + this.denuncia[0].id_denuncia;

                      this.receptor.forEach(receiver => {
                        const messageReceptor = `${this.translate.instant('texto_576')} ${receiver.id_user}${this.translate.instant('texto_592')}${idShown} ${this.translate.instant('texto_619')}`;

                        this.apiService.sendEmail(receiver.id_user, this.translate.instant('texto_618'), messageReceptor, url, false, this.translate.instant('texto_618'), 'gestor')
                          .subscribe(resp => {
                            if (resp == 200) {
                              this.toastr.success(this.translate.instant('texto_532'), this.translate.instant('texto_533'));
                              this.redirectAfterSend(receiver.id_user);
                            } else {
                              this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));
                            }
                          }, () => {
                            this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));
                          });
                      });

                    });
                });
            });
        });
    }

  }

  /** Initialize personalizable id flag. */
  private setupPersonalizable(): void {
    if (this.auth.getIdPersonalizable() == '1') {
      this.isActiveIdPersonalizable = true;
    }
  }

  /** Return the complaint identifier to show (personalizable if active). */
  private getIdDenunciaShown(): string {
    return this.isActiveIdPersonalizable ? (this.denuncia[0].identificador_denuncia || this.denuncia[0].id_denuncia) : this.denuncia[0].id_denuncia;
  }

  /** Get user roles and redirect the current user after successful send. */
  private redirectAfterSend(targetUserId: string): void {
    this.apiService.searchRoleByUserSociety('setUser', this.auth.getSociedad(), '1').subscribe({
      next: (roles) => {
        if (roles.success && roles.code === 200) {
          this.roles = roles.data;
          let role = '';
          for (let i = 0; i < this.roles.length; i++) {
            role += ',' + this.roles[i].id_rol;
          }

          if (role.includes('1') && targetUserId == this.auth.getIdUser()) {
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
            });
          } else {
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['dashboard/complaint-management/mis-denuncias']);
            });
          }
        }
      }, error: () => {
        this.toastr.error(this.translate.instant('texto_915'), this.translate.instant('texto_813'));
      }
    });
  }

  getTextoInformeError(): string {
    const errors = this.texto?.errors;

    if (errors?.['required'] || errors?.['whitespace'] || errors?.['minlength']) {
      return this.translate.instant('texto_180');
    }

    return '';
  }

  // Subscribe to value changes to always keep the character count updated.
  updateCharCount() {
    this.texto?.valueChanges.subscribe((value: string) => {
      this.charCount = value ? value.length : 0;
    });
  }

  // Validates HTML input, updates character count, and reverts to last valid value if limit is exceeded.
  onEditorChange(value: string) {
  const plainText = value
    ? value.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim()
    : '';

  this.charCount = plainText.length;

    if (plainText.length <= this.maxCharCount) {
    this.lastValidHTML = value;
    this.textoInforme = value;
   }
  }

  // Extract plain text from HTML, removing all tags and formatting
  private extractPlainText(html: string): string {
    if (!html) return '';
    return html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .trim();
  }

};
